import { render, staticRenderFns } from "./KpiMcrCreation.vue?vue&type=template&id=006aa1ed"
import script from "./KpiMcrCreation.vue?vue&type=script&lang=js"
export * from "./KpiMcrCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports